<template>
  <div class="home">
    <v-row class="callout-section-row">
      <v-col cols="12" class="callout-section px-9">
        <v-row class="justify-end pb-12">
          <v-col cols="12" md="6" class="">
            <div class="callout  mx-auto">
              <div class="headline-text text-center">
                Startup Friendly Product Development<br />
                <!-- Let Your Startup <br />
                Fly With Hive -->
              </div>

              <!-- <p class="title text-center mt-3"> -->
              <!-- Join our community to get support and guidance . -->
              <!-- Join our community to get support and guidance as you tackle the
            market and search for product-market fit. -->
              <!-- build your MVP and find product-market fit faster -->
              <!-- </p> -->
              <div class="text-center mb-12">
                <v-btn
                  dark
                  x-large
                  color="cta"
                  large
                  @click="scrollTo('applyform')"
                >
                  Contact Us</v-btn
                >
              </div>
            </div>
          </v-col>
        </v-row>
        <!-- <div class="headline mt-2 mt-md-5 ml-1 pb-5 pb-md-10">
          Hive Network is a collaborative platform designed to help new startups
          succeed.
        </div>-->
        <!-- <div class="headline ml-1 mt-5 text-center">
          You bring the idea we help with the rest.
        </div>-->
      </v-col>
    </v-row>
    <v-row>
      <!-- <what do you get -->
      <v-col cols="12" class="what-you-get pa-9">
        <div class="display-1 mt-5">How We Help</div>
        <v-row class="mt-5 justify-center">
          <v-col cols="12" md="4">
            <v-card class="mx-auto" max-width="450" min-height="230" outlined>
              <h2 class="text-center font-weight-bold mb-1">
                Product Strategy
              </h2>
              <div class="px-5">
                <!-- <div class="text-center font-weight-bold">
                  Meet with a member of our mentor team every 2 weeks
                </div> -->
                <!-- to ensure your product is heading in the right direction. -->
                <p class="text-left mt-2">
                  Meet with a member of our strategy team every 2 weeks to plan
                  your product roadmap.
                </p>
              </div>
              <!-- <div class="text-center learn-more">
                <v-btn
                  class="apply-btn mt-auto"
                  color="primary"
                  href="/mentorship"
                  >Learn More</v-btn
                >
              </div> -->
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card class="mx-auto" max-width="450" min-height="230" outlined>
              <h2 class="text-center font-weight-bold mb-1">
                Development Teams
              </h2>
              <div class="px-5">
                <!-- <div class="text-center font-weight-bold">
                  Hire a team of coders, designers, and product owners
                </div> -->
                <p class="text-left mt-2">
                  We have all the resources you need to go from idea to
                  product-market fit. Hive provides and manages a development
                  team so you can focus on your startup.
                </p>
              </div>
              <!-- <div class="text-center learn-more">
                <v-btn
                  class="apply-btn mt-auto"
                  color="primary"
                  href="/development-teams"
                  >Learn More</v-btn
                >
              </div> -->
            </v-card>
          </v-col>
          <!-- <v-col cols="12" md="4">
            <v-card class="mx-auto" max-width="450" min-height="230" outlined>
              <h2 class="text-center font-weight-bold mb-1">
                Team Management
              </h2>
              <div class="px-5">
                <span class="text-center font-weight-bold">
                  We manage the developer network teams so you can focus on your
                  startup.
                </span>
                <p class="text-left mt-2">
                  You communicate your goals and we assemble a team for your
                  exact needs. No need to bog your startup down with full-time
                  development resources.
                </p>
              </div>
              <div class="text-center learn-more">
                <v-btn
                  class="apply-btn mt-auto"
                  color="primary"
                  href="/support-teams  "
                  >Learn More</v-btn
                >
              </div>
            </v-card>
          </v-col> -->

          <v-col cols="12" md="4">
            <v-card class="mx-auto" max-width="450" min-height="230" outlined>
              <h2 class="text-center font-weight-bold mb-1">
                Support Teams
              </h2>

              <div class="px-5">
                <!-- <div class="text-center font-weight-bold">
                  Hire a support team to maintain your product
                </div> -->
                <p class="text-left mt-2">
                  Hire a support team to maintain your product to ensure your
                  system is up and functioning consistently. All plans are month
                  to month so they grow with your startup.
                </p>
              </div>
              <!-- <div class="text-center learn-more">
                <v-btn
                  class="apply-btn mt-auto"
                  color="primary"
                  href="/support-teams"
                  >Learn More</v-btn
                >
              </div> -->
            </v-card>
          </v-col>
          <!-- <v-col cols="12" md="4">
            <v-card class="mx-auto" max-width="450" min-height="230" outlined>
              <h2 class="text-center font-weight-bold mb-1">
                Tools
              </h2>
              <div class="px-5">
       
                <p class="text-left mt-2">
                  Get access to our tools to help you organize your ideas.
                  Measure your progress and communicate your needs to your
                  internal team and your hive developer network team.
                </p>
              </div>
       
            </v-card>
          </v-col> -->
        </v-row>

        <div class="display-1 mt-5 text-center">
          <v-btn x-large href="/services" dark color="cta">
            View All Services</v-btn
          >
        </div>
      </v-col>
      <!-- end what do you get -->
      <!-- how it works -->
      <!-- <v-col cols="12" class="how-it-works pa-9">
        <div class="display-1 mt-5 text-center">How It Works</div>
        <v-row class="mt-5 justify-center">
          <v-col cols="12" md="6">
            <div class="how-it-works-item">
              <h3>1. Join</h3>
              <p>
                Apply and we will review your application. Once accepted, you
                will get access to our startup management tools and set up your
                1st mentor meeting.
              </p>
            </div>
          </v-col>
  
          <v-col cols="12" md="6">
            <div class="how-it-works-item">
              <h3>2. Plan</h3>
              <p>
                Use the tools to communicate your goals, assign goals to a team
                (yours or a Hive team), and request a quote for each goal.
              </p>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div class="how-it-works-item">
              <h3>3. Get to work</h3>
              <p>
                Once accepted, the teams will get to work building your product.
           
              </p>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div class="how-it-works-item">
              <h3>4. Learn and Iterate</h3>
              <p>
                Track your progress and review your product with our mentorship
                team every 2 weeks to ensure your product stays on track.
            
              </p>
            </div>
          </v-col>
        </v-row>
      </v-col> -->

      <!-- end how it works -->
      <!-- cost -->

      <!-- <h4>Ways to Pay</h4>

            <ul>
              <li>A percent of revenue with a 50% reduced cash payment.</li>
              <li>Some equity with a 50% reduced cash payment.</li>
              <li>Cash at a discouted in network rate</li>
            </ul> -->

      <!-- <p>
              Once accpeted, it is free to be a membor of the network.
            </p>
            <div>
              If you choose to hire a Hive Development Team there are 3 ways to
              pay for developemnt resources.
              <ul>
                <li>A percent of revenue with a reduced cash payment.</li>
                <li>Some equity with a reduced cash payment..</li>
                <li>Cash at a discouted in network rate</li>
              </ul>
            </div> -->
      <!-- <p>
              You can hire a developer network team at a highly discounted rate
              if you are accepted into the network.
            </p> -->
      <!-- en dcost -->
      <!-- members -->
      <v-col cols="12" class="pa-9 my-5">
        <h2 class="display-1 mt-5 mb-5 text-center">Network Partners</h2>
        <v-row class="mt-0 mt-md-5 justify-center">
          <v-col cols="12" md="4">
            <v-card class="pa-5">
              <v-img src="/img/network-partners/apn-aws-logo.png"> </v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" class="our-startups-wrapper pa-9 mt-1">
        <v-divider> </v-divider>
        <h2 class="display-1 mt-5 text-center">A Few Of Our Clients</h2>
        <v-row class=" our-startups">
          <v-col cols="12">
            <v-carousel
              cycle
              min-height="400"
              hide-delimiter-background
              show-arrows-on-hover
            >
              <v-carousel-item v-for="member in members" :key="member.id">
                <v-row class="fill-height" align="center" justify="center">
                  <div class="col-12 client-slide">
                    <div class="display-1 text-center mb-2">
                      {{ member.name }}
                    </div>
                    <v-img
                      class="mx-auto"
                      height="290px"
                      :src="member.imageURL"
                    ></v-img>
                    <p class="text-center mt-2">
                      {{ member.desc }}
                    </p>
                  </div>
                </v-row>
              </v-carousel-item>
            </v-carousel>
          </v-col>
        </v-row>
      </v-col>
      <!-- <v-col cols="12" class="what-does-it-cost pa-9 mt-10">
        <div class="display-1 mt-5">
          Flexible Ways to Pay For The Development Network
        </div>
        <ul>
          <li>A percent of revenue with a 50% reduced cash payment.</li>
          <li>Some equity with a 50% reduced cash payment.</li>
          <li>Cash at a discouted in network rate</li>
        </ul>
      </v-col> -->
    </v-row>
    <v-divider> </v-divider>
    <!-- <v-row class="contact-us">
      <div ref="applyform" id="applyform"></div>
      <v-col cols="12" class="pa-9 mt-1  text-center">
        <div class="display-1 mt-5  text-center">
          Contact Us
        </div>
        <div class="text-center text-center">
          We would love to chat about your startup!
        </div>
        <div class="upscribe-embed-wrapper">
          <div id="applyform" class="upscribe-embed" data-src="https://upscri.be/2vznx4"></div>
        </div>
      </v-col>

      <v-col cols="12" class="pa-9 mt-12 bg-dark ">
        <div class="display-1 text-center mb-5">Questions? Email Us</div>
        <div class="upscribe-embed" data-src="https://upscri.be/i2vwv9"></div>
      </v-col>

    </v-row> -->
    <v-row class="contact-us" ref="applyform" id="applyform">
      <v-col cols="12" class="pa-9 mt-1 text-center">
        <div class="mx-auto form-wrapper">
          <div class="mb-2">
            <h2>Contact Us</h2>
            <div>We would love to chat about your Startup!</div>
          </div>
          <ConvertKitForm v-bind="config" />
        </div>
      </v-col>
    </v-row>
    <!-- <div class="row mt-sm-5 pb-5 mb-5">
      <v-col cols="12" class="pa-2 pa-sm-9 mt-12 bg-dark">
        <div class="display-1 text-center mb-0 mt-5">
          Questions? Give us a call
          <strong>
            <a href="tel:‪1-720-634-5985‬">‪(720) 634-5985‬</a>
          </strong>
        </div>
      </v-col>
    </div> -->
    <v-dialog v-model="thanksDialog" max-width="550px">
      <v-card class="bg-white pa-12">
        <v-alert type="success"
          >Thanks for contacting us! We will be in touch soon.</v-alert
        >
        <div class="text-center">
          <v-btn
            class="mx-auto mt-1"
            @click="
              thanksDialog = false;
              $router.replace('/');
            "
          >
            close</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<style lang="scss" scoped>
.text-red {
  color: red;
}

.cross-out {
  text-decoration: line-through;
}

.bg-dark {
  background-color: var(--v-grey-darken3);

  .display-1 {
    color: var(--v-primary-base);
  }
}

.our-startups a {
  color: black;
}

.contact-us {
}

.upscribe-embed-wrapper {
  margin: -20px -40px 0 -40px;
}

.what-you-get,
.what-does-it-cost {
  // min-height: 200px;
  background-color: var(--v-grey-darken3);
  color: white;
}

.what-you-get .display-1,
.what-does-it-cost .display-1 {
  color: var(--v-primary-base);
}

.what-you-get h2 {
  // background-color: silver;
  // border-bottom: 1px solid #ededed;
  margin: 0;
  padding: 10px 10px 0 10px;
}

.callout {
  max-width: 850px;

  .headline-text {
    font-size: 2rem;

    @media (min-width: 321px) {
      font-size: 2.4rem;
    }

    @media (min-width: 1200px) {
      font-size: 3.75rem;
    }
  }
}

.request-chat-wrapper {
  margin-top: -40px;
  max-height: 170px;
  overflow: hidden;
}

.apply-btn {
  color: white;
  font-weight: 800;
}

.our-startups {
  max-width: 800px;
  margin: auto;
}

.how-it-works-item {
  max-width: 450px;
  margin: auto;
}

.client-slide {
  // background-color: var(--v-grey-darken3);
}

.v-application .home .display-1 {
  font-size: 1.9rem !important;
}

.form-wrapper {
  max-width: 600px;
  margin: auto;
}

@media (min-width: 500px) {
  .v-application .home .display-1 {
    font-size: 2.125rem !important;
  }
}

.callout-section-row {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  // padding: 20px 0;
  // width: 100%;
  position: relative;
  background-position: center 265px;
  background-size: 1100px auto;
  background-image: url("/img/people-bg-mobile.svg");
  min-height: 625px;
}

@media (min-width: 957px) {
  .callout-section-row {
    background-position: -300px top;

    background-image: url("/img/people-bg-mobile.svg");
    padding-bottom: 0px;
    min-height: 0px;
    background-size: 1100px auto;
  }
}

@media (min-width: 1180px) {
  .callout-section-row {
    background-position: left top;
  }
}

.learn-more {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  margin: 0 auto;
}
</style>
<script>
import ConvertKitForm from "convertkit-vue";
export default {
  name: "Home",
  components: { ConvertKitForm },
  mounted() {
    const { action } = this.$route.query;
    if (action && action === "thanks") {
      // alert("Thanks for contacting us! We will be in touch soon.");
      this.thanksDialog = true;
    }
  },
  data() {
    return {
      thanksDialog: false,
      config: {
        formId: 5835784,
        template: "clare",
        emailPlaceholder: "Enter an email address",
        submitText: "Contact Us",
        namePlaceholder: "Name",
      },
      members: [
        {
          name: "A Sales Guy",
          desc: "Online training platform for starups to foutune 50 companies.",
          logoURL: "img/startups/logos/asg-logo.png",
          imageURL: "img/startups/asalesguy.jpg",
        },
        {
          name: "Hometraq",
          desc: "Home showings on demand.",
          logoURL: "img/startups/logos/hometraqlogo.png",
          imageURL: "img/startups/hometraq.jpg",
        },
        {
          name: "Maritz Motivation",
          desc:
            "Maritz Motivation designs programs that align with your business values to spark action.",
          logoURL: "img/startups/logos/maritz_logo.png",
          imageURL: "img/startups/maritz.jpg",
        },
        {
          name: "Rigcallout",
          desc:
            "Visibility in the Oilfield Supply Chain No Matter Who is Supplying, Shipping, or Receiving",
          logoURL: "img/startups/logos/RigCallOut_logo.webp",
          imageURL: "img/startups/callout.jpg",
        },
        {
          name: "Bear Systems",
          desc:
            "The Only Universal Cybersecurity Platform Powered by Helpful AI",
          logoURL: "img/startups/logos/BearLogo.png",
          imageURL: "img/startups/bearsystems.jpg",
        },
      ],
    };
  },
  methods: {
    scrollTo(ref) {
      this.$refs[ref].scrollIntoView();
    },
  },
};
</script>
